<template>
  <div class="tool">
    <header class="tool__banner">
      <h3 class="tool__banner__title">一个好用的在线旅游商城</h3>
      <div class="tool__banner__desc"
        v-html="'平台提供海量高端、优质、高利润产品资源的同时，还提供专属在线旅游商城，帮助企业快速<br/>升品牌曝光度，帮助同业开设新阵地、开拓新客群、收获生意新增长'"></div>
    </header>
    <ul class="tool__nav">
      <li class="tool__nav__item" v-for="nav in navs" :key="nav.icon">
        <p class="tool__nav__item__title">{{ nav.title }}</p>
        <p class="tool__nav__item__desc">{{ nav.desc }}</p>
        <el-image class="tool__nav__item__icon" fit="cover" :src="nav.icon"></el-image>
      </li>
    </ul>

    <div class="tool__section">
      <div class="tool__section__slide">
        <p class="tool__section__title">店铺装修</p>
        <p class="tool__section__desc">20+种装修组件任意组合，3分钟拥有专属商城</p>
        <div>
          <nuxt-link to="/designer" target="_blank">
            <el-button type="primary">立即体验</el-button>
          </nuxt-link>
          <!-- <div class="tool__section__btn__video" @click="showVideoDialog('designer')">
            <i class="ficon ficon-shipin1"></i>
            视频讲解
          </div> -->
        </div>
      </div>
      <el-image class="tool__section__priview" fit="cover"
        src="@/assets/img/topic/shop-tool/intro_designer.png"></el-image>
    </div>

    <div class="tool__section">
      <el-image class="tool__section__priview" fit="cover"
        src="@/assets/img/topic/shop-tool/intro_pickandshare.png"></el-image>
      <div class="tool__section__slide">
        <p class="tool__section__title">选品及分享</p>
        <p class="tool__section__desc">大家都在卖什么？卖什么最赚钱？选好了怎么分享给客户</p>
        <div>
          <nuxt-link to="/resource/product/list/cruise" target="_blank">
            <el-button type="primary">立即体验</el-button>
          </nuxt-link>
          <!-- <div class="tool__section__btn__video" @click="showVideoDialog('pick')">
            <i class="ficon ficon-shipin1"></i>
            视频讲解
          </div> -->
        </div>
      </div>
    </div>

    <div class="tool__section">
      <div class="tool__section__slide">
        <p class="tool__section__title">二维码工具</p>
        <p class="tool__section__desc">搭建专属二维码管理系统，与自身业务有机结合，内容不限，容量不限</p>
        <div>
          <nuxt-link to="/resource/tools/qrcode" target="_blank">
            <el-button type="primary">立即体验</el-button>
          </nuxt-link>
          <!-- <div class="tool__section__btn__video" @click="showVideoDialog('qrcode')">
            <i class="ficon ficon-shipin1"></i>
            视频讲解
          </div> -->
        </div>
      </div>
      <el-image class="tool__section__priview" fit="cover" src="@/assets/img/topic/shop-tool/intro_qrcode.png"></el-image>
    </div>

    <div class="tool__section">
      <el-image class="tool__section__priview" fit="cover" src="@/assets/img/topic/shop-tool/intro_sms.png"></el-image>
      <div class="tool__section__slide">
        <p class="tool__section__title">会员短信营销</p>
        <p class="tool__section__desc">会员体系精细化运营，3秒精准触达，提升复购率</p>
        <div>
          <nuxt-link to="/resource/tools/message/recharge" target="_blank">
            <el-button type="primary">立即体验</el-button>
          </nuxt-link>
          <!-- <div class="tool__section__btn__video" @click="showVideoDialog('sms')">
            <i class="ficon ficon-shipin1"></i>
            视频讲解
          </div> -->
        </div>
      </div>
    </div>

    <div class="tool__section">
      <div class="tool__section__slide">
        <p class="tool__section__title">素材中心</p>
        <p class="tool__section__desc">提供产品相关精美素材，视频、海报、相关文档等</p>
        <div>
          <nuxt-link to="/resource/material" target="_blank">
            <el-button type="primary">立即体验</el-button>
          </nuxt-link>
          <!-- <div class="tool__section__btn__video" @click="showVideoDialog('material')">
            <i class="ficon ficon-shipin1"></i>
            视频讲解
          </div> -->
        </div>
      </div>
      <el-image class="tool__section__priview" fit="cover"
        src="@/assets/img/topic/shop-tool/intro_material.png"></el-image>
    </div>

    <div class="tool__bottom" v-if="!shopOpenStatus">
      <el-button class="tool__bottom__btn" @click="dialogVisible = true">
        <i class="ficon ficon-xianshimiaosha tool__bottom__icon"></i>
        限时免费开通</el-button>
    </div>

    <el-dialog title="申请开通" :visible.sync="dialogVisible" width="30%">
      <span>确定免费开通营销店铺服务吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOpening">开通</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { applyOpening } from '@/services/topic'
import { Message } from 'element-ui';
// 测试视频播放
// https://v.shangchuanba.com/%E4%B8%8A%E8%88%B9%E5%90%A7/uploads/1626868780988487.mp4
const videoSrcMap = {
  designer:
    "https://v.shangchuanba.com/%E4%B8%8A%E8%88%B9%E5%90%A7/uploads/1626868780988487.mp4",
  pick: "https://v.kkxjyj.net/v/t/202202/yvf74chaj672an5z40.mp4",
  qrcode:
    "https://v.shangchuanba.com/%E4%B8%8A%E8%88%B9%E5%90%A7/uploads/1626868780988487.mp4",
  sms: "https://v.kkxjyj.net/v/t/202202/yvf74chaj672an5z40.mp4",
  material:
    "https://v.shangchuanba.com/%E4%B8%8A%E8%88%B9%E5%90%A7/uploads/1626868780988487.mp4",
};
export default {
  name: 'ShopTool',
  components: {},
  head: {
    title: "申请开通"
  },
  data() {
    return {
      navs: [
        {
          title: "企业品牌曝光",
          desc: "助力同业完善品牌形象，提升品牌影响力，增加品牌曝光",
          icon: require("@/assets/img/topic/shop-tool/icon_nav_1.png"),
        },
        {
          title: "海量产品资源",
          desc: "自主打包，包船及邮轮公司直连获取一手资源，去除中间商",
          icon: require("@/assets/img/topic/shop-tool/icon_nav_2.png"),
        },
        {
          title: "免费营销工具",
          desc: "优惠套餐，满减、拼团等多种免费营销工具激活沉默用户，促转化提业绩",
          icon: require("@/assets/img/topic/shop-tool/icon_nav_3.png"),
        },
        {
          title: "快速裂变分销",
          desc: "裂变分销快速拓展销售渠道, 促进商家业绩增长",
          icon: require("@/assets/img/topic/shop-tool/icon_nav_4.png"),
        },
      ],
      dialogVisible: false
    };
  },
  computed:{
    shopOpenStatus() {
      return this.$store.getters.isOpenShop;
    },
  },
  methods: {
    showVideoDialog(type) {
      const videoSrc = videoSrcMap[type];
      this.$createVideoDialog({
        $props: {
          src: videoSrc,
        },
      }).show();
      //
    },
    async handleOpening() {
      const { code, msg } = await applyOpening()
      if (code === 10000) {
        Message.success('开通成功')
        this.dialogVisible = false;
        setTimeout(() => {
          this.$router.push('/resource/shop/productmanagement')
        }, 1000)
      } else {
        Message.error(msg)
      }
    }
  },
};
</script>
<style lang="scss" scoped>

.tool {
  background-color: #fff;

  &__banner {
    color: #fff;
    height: 666px;
    background: url("~@/assets/img/topic/shop-tool/banner.png") center no-repeat;
    background-color: #ebf0ff;
    background-size: 1920px 666px;
    padding-top: 230px;
    text-align: center;

    &__title {
      color: #212529;
      font-size: 55px;
      font-weight: 600;
      margin-bottom: 25px;
    }

    &__desc {
      color: #495057;
      font-size: 20px;
    }
  }

  // 导航
  &__nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1206px;
    margin: -55px auto 0;

    &__item {
      width: 285px;
      height: 192px;
      border-radius: 20px;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
      color: #fff;
      padding: 28px;
      position: relative;

      &:nth-child(1) {
        background: linear-gradient(137deg, #fe9841 0%, #ffc976 100%);
      }

      &:nth-child(2) {
        background: linear-gradient(133deg, #22b8cf 0%, #47dde9 100%);
      }

      &:nth-child(3) {
        background: linear-gradient(133deg, #228be6 0%, #47bff4 100%);
      }

      &:nth-child(4) {
        background: linear-gradient(133deg, #f25b3b 0%, #fa946d 100%);
      }

      &__title {
        font-size: 18px;
        font-weight: 600;
      }

      &__desc {
        font-size: 14px;
        padding-right: 20px;
        position: relative;
      }

      &__icon {
        width: 95px;
        height: 102px;
        position: absolute;
        right: 0;
        bottom: -5px;
      }
    }
  }

  //
  &__section {
    width: 1206px;
    margin: 0 auto;
    display: flex;
    padding: 40px 0;

    &__priview {
      width: 590px;
      height: 395px;
    }

    &__slide {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 605px;
      height: 404px;
      padding-left: 110px;
    }

    &__title {
      color: #333;
      font-size: 32px;
      margin-bottom: 10px;
      font-weight: 500;
    }

    &__desc {
      color: #495057;
      font-size: 18px;
      margin-bottom: 40px;
    }

    &__btn__video {
      display: inline-flex;
      align-items: center;
      height: 40px;
      color: #f25b3b;
      font-size: 14px;
      font-weight: 500;
      vertical-align: top;
      margin-left: 10px;
      cursor: pointer;

      .ficon {
        margin-right: 5px;
      }
    }
  }

  &__bottom {
    width: 100%;
    position: sticky;
    bottom: 0px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(180deg, #F2F6FF 0%, #DBE3FF 100%);
    text-align: center;
    color: $text-color-dark;

    &__btn {
      background: $color-yellow-3;
      border-radius: 4px;
      padding: 12px 20px 8px;
    }

    &__icon {
      font-size: 17px;
      vertical-align: middle;
      display: inline-block;
      margin-bottom: 3px;
    }
  }
}

</style>